// --------------------------------------------------------------
// Created On: 2025-10-29
// Author: Zachary Thomas
//
// Last Modified: 2025-11-02
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { useDispatch } from "react-redux";
import { ReduxDispatch } from "../redux/store";

// Hook for dispatching Redux actions.
const useReduxDispatch: () => ReduxDispatch = useDispatch;
export default useReduxDispatch;
